<template>
  <div class="ui-pop" v-show="info.show">
    <div class="ui-mask"></div>
    <div class="ui-modal large">
      <!-- 邀约确认 -->
      <div class="title" v-if="info.type === 2">Invitation confirmation</div>
      <!-- 审核 -->
      <div class="title" v-else>Lesson Reschedule Approval</div>
      <a class="modal-close" @click="info.show = false"
        ><i class="el-icon-close"></i
      ></a>
      <div class="content">
        <template v-if="info.type === 2">
          <div class="item ask">
            <div class="row">
              <!-- 邀约对象 -->
              <span class="lab">Send lesson invitation to</span>
              <span class="info">{{ info.name }}</span>
            </div>
            <!-- 课程信息 -->
            <p class="tip">Lesson info</p>
            <p class="info" v-for="(item, index) in info.list" :key="index">
              <span class="lab">{{ item.week }}:</span> {{ item.dateTime }}
              {{ item.num }}{{ $t('common.lessons') }}
            </p>
          </div>
        </template>
        <template v-else>
          <!-- 改签信息 -->
          <p class="topic">Rescheduling Details</p>
          <div class="item">
            <div class="row">
              <!-- 课时数 -->
              <span class="lab">No. of lessons：</span>
              <span class="info"
                >{{ info.course }} {{ $t('common.lessons') }}</span
              >
            </div>
            <div class="row">
              <!-- 改签前 -->
              <span class="lab">Before：</span>
              <span class="info">{{ info.before }}</span>
            </div>
            <div class="row">
              <!-- 改签后 -->
              <span class="lab">After：</span>
              <span class="info">{{ info.after }}</span>
            </div>
          </div>
        </template>
        <div class="btns">
          <a class="ui-btn gray" @click="refused()">{{ info.cancel }}</a>
          <a class="ui-btn" @click="agree()">{{ info.comfirm }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['info'],
  methods: {
    agree() {
      this.$emit('comfirm')
    },
    refused() {
      this.$emit('refuse')
    }
  }
}
</script>
<style lang="scss" scoped>
.ui-modal {
  height: 560px;
}
.title {
  padding: 57px 50px 43px;
  line-height: 42px;
  border-bottom: 1px solid #d6d6d6;
  font-size: 32px;
  text-align: center;
}
.content {
  padding: 60px 100px 50px;
  text-align: center;
}
.topic {
  font-weight: bold;
  font-size: 21px;
  line-height: 27px;
}
.row {
  margin-top: 20px;
  line-height: 24px;
  font-size: 18px;
}
.item {
  display: inline-block;
  text-align: left;
}
.lab {
  margin-right: 10px;
  color: #000;
}
.info {
  color: #999;
}
.ask {
  color: #000;
  font-size: 18px;
  line-height: 33px;
}
.tip {
  margin-top: 10px;
  color: #000;
  font-size: 18px;
}
.btns {
  margin-top: 60px;
}
</style>